export default class CalendarType {
  calendarTypeId?: number;
  name?: string | null;

  public constructor(params: CalendarType = {} as CalendarType) {
    let { calendarTypeId = 0, name = "" } = params;
    this.calendarTypeId = calendarTypeId;
    this.name = name;
  }
}
